// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/vuetify'
import App from './App'
import Survey from './components/Survey'
import router from './router'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.use(VueAnalytics, {
  id: 'UA-144475633-1',
  router
  /*,debug: {
    enabled: true
  }*/
})

window.survey = app.$children[0].$children[0];


// WEBPACK FOOTER //
// ./src/main.js